import { useEffect } from 'react';
import { useRoutes, useNavigate } from 'react-router-dom';

import { Routes } from './routes';
import { ProtectedRoute, AlreadyLoggedIn } from '@middlewares';

import Welcome from '@pages/Welcome/Welcome';
import NotFound from '@pages/auth/NotFound';

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    sessionStorage.clear();
    navigate('/login');
  }, [navigate]);

  return null;
};

const Router = () => {
  const routes = useRoutes([
    {
      path: '/',
      element: <AlreadyLoggedIn />,
    },
    {
      path: '/welcome',
      element: <ProtectedRoute title="Inicio" page={<Welcome />} />,
    },
    {
      path: '/logout',
      element: <Logout />,
    },
    {
      path: '*',
      element: <NotFound />,
    },
    ...Routes,
  ]);

  return routes;
};

export default Router;
